<template>
  <div class="modals">
    <portal-target name="photoGallery" />
    <portal-target name="ChoiceRegion" />
    <portal-target name="SearchSuggest" />
    <portal-target name="MenuCatalogM" />
    <portal-target name="NoAvailable" />
    <portal-target name="PdfReader" />
    <portal-target name="FastCert" />
    <portal-target name="CallOrderModalD" />
    <portal-target name="CallEditOrderModalD" />
    <portal-target name="PartnerLinkModal" />
    <portal-target name="CallArrivalProductModalD" />
    <portal-target name="ModalWidgetRecommendation" />
  </div>
</template>

<script>
export default {
  name: 'PortalsTarget',
};
</script>
